import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { QuickAccessRibbon } from '../components/QuickAccessRibbon';
import { SearchService } from '../components/SearchService';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorks } from '../components/HowItWorks';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FeesSection } from '../components/FeesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { ContactSection } from '../components/ContactSection';
import { NotSureSection } from '../components/NotSureSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-1015" />
      <QuickAccessRibbon data-id="element-1016" />
      <SearchService data-id="element-1017" />
      <AboutSection data-id="element-1018" />
      <ServicesSection data-id="element-1019" />
      <HowItWorks data-id="element-1020" />
      <TestimonialsSection data-id="element-1021" />
      <FeesSection data-id="element-1022" />
      <ResourcesSection data-id="element-1023" />
      {/* Book Appointment CTA */}
      <section className="py-16 lg:py-20 bg-olive" data-id="element-1024">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1025">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-1026">
            Ready to Start Your{' '}
            <span className="italic text-gold" data-id="element-1027">Healing Journey?</span>
          </h2>
          <p className="text-white/80 text-base md:text-lg font-medium mb-8 max-w-xl mx-auto" data-id="element-1028">
            Take the first step today. Book an appointment online — no referral
            required, no waitlist.
          </p>
          <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-gold hover:bg-gold/90 text-white px-10 py-4 rounded-full font-bold text-base transition-all shadow-lg min-h-[52px] tracking-wide uppercase" data-id="element-1029">
            Book An Appointment
          </a>
        </div>
      </section>
      <ContactSection data-id="element-1030" />
      <NotSureSection data-id="element-1031" />
    </>;
}